import React from 'react';
import PropTypes from 'prop-types';
import { Field, propTypes as ReduxFormPropTypes } from 'redux-form';
import { defineMessages, useIntl } from 'react-intl';
import { SocialMediaInput, InputLabel } from 'components/Form';
import { SvgInstagramLogo } from 'components/Svgs/';

// TODO(i18n): Either `other` isn't necessary or this list is incomplete.
// We map over fields but all <SocialMediaLabel> have <SvgInstagramLogo>?
const messages = defineMessages({
  instagram: {
    id: 'instructor-form.social-media.instagram',
    defaultMessage: 'Instagram',
  },
  other: {
    id: 'instructor-form.social-media.other',
    defaultMessage: 'Other',
  },
});

const SocialMediaLabel = ({ input: { value, name } }) => {
  const intl = useIntl();
  return (
    <InputLabel name={name} optional>
      <div className="instructor-form__social-label">
        <SvgInstagramLogo className="instructor-details__social-media-icon" />
        {intl.formatMessage(messages[value])}
      </div>
    </InputLabel>
  );
};

SocialMediaLabel.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    name: PropTypes.string,
  }),
};

const InstructorFormSocialMedia = ({ fields }) => (
  <div>
    {fields.map(item => (
      <div key={item}>
        <Field name={`${item}.service`} component={SocialMediaLabel} />
        <Field
          name={`${item}.userName`}
          className="instructor-form__single-input"
          staticText="@"
          component={SocialMediaInput}
        />
      </div>
    ))}
  </div>
);

InstructorFormSocialMedia.propTypes = {
  fields: PropTypes.shape(ReduxFormPropTypes.fieldArrayFieldsPropTypes),
};

export default InstructorFormSocialMedia;
